<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_3744_8381)">
      <path
        d="M21 0L2 0L2 24L21 24L21 0ZM11.5 23C10.67 23 10 22.33 10 21.5C10 20.67 10.67 20 11.5 20C12.33 20 13 20.67 13 21.5C13 22.33 12.33 23 11.5 23ZM19 19L4 19L4 3L19 3L19 19Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_3744_8381">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
